var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"page page-emergency-inspect-photos"},[_c('detail-photos',{attrs:{"id":_vm.id,"photo-type":"correctionContentBeforePhotoList","api-name":"correctionReport"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }